import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import BulkUpdateButton from '../../../components/bulk-update-menu';

const mapStateToProps = (state) => {
  const selectedIds = Global.selectSelectedOrdersIds(state);
  const allSelected = Global.selectSelectedOrdersAreAllOrdersSelected(state);
  const isGroupbyActive = Global.selectOrdersGridActiveGroupByEnums(state).length;
  const pendoTrackingId = isGroupbyActive ? '/orders#group-by-bulk-update' : '';
  return {
    pendoTrackingId,
    optionsShouldBeDisabled: !allSelected && !selectedIds.length,
  };
};

export const BulkUpdateButtonContainer = connect(mapStateToProps)(BulkUpdateButton);
